var CustomPickup = {
  init: function(withCallback) {
    if ($('#storePickupApp').length > 0) {
      this.shippingButton = $('#shipping-button');
      this.pickupButton = $('#pickup-button');
      this.pickupSelector = $('.pickup-selector');
      this.pickupContainer = $('.pickup-location-container');
      this.pickupLocations = $('.pickup-locations');
      this.shippingContainer = $('.shipping-container');
      this.shippingBox = $('.shipping-dynamic-area');
      this.checkoutButton = $('button.cart-recap__checkout')
      this.searchBox = $('#search_location');
      this.serviceArea = $('.service-area');
      this.checkoutButton = $('button[name=checkout]');
      //this.endpoint = "https://uat.esis.smappliance.com/cms/";
      this.endpoint = "https://prod.esis.smappliance.com/cms/";
      this.cartContent = null;    
      this.mode = 'delivery';    
      this.sprovinceSelector = 'select#shipping_province';
      this.scitySelector = 'select#shipping_city';
      this.sbarangaySelector = 'select#shipping_barangay';
      this.provinceSelector = 'select#province';
      this.citySelector = 'select#city';
      this.barangaySelector = 'select#barangay';
      this.getCart(withCallback);
      this.attachEvents();    
      this.getServiceableRegions();

      window.localStorage.removeItem("__ui");
      
      var self = this;
      
      $('button.quantity-selector__button').unbind('click');
      $('button.quantity-selector__button').bind('click', function(e) {        
		self.listenToChange();
      });

    }
  },
  
  listenToChange: function() {    
    console.log ("attch dom change");
    $('section[data-section-id=cart-template]').bind('DOMSubtreeModified', function () {
      $('section[data-section-id=cart-template]').unbind('DOMSubtreeModified');
      setTimeout(function() {
     	  CustomPickup.init(true); 
      }, 200);
	});

  },
  
  attachEvents: function() {
    var self = this;
    
    this.checkoutButton.text("Checkout");

    this.shippingButton.unbind('click');    
    this.shippingButton.bind('click', function(e) {
	    self.method = 'delivery';
    	self.pickupSelector.removeClass('active');
        self.pickupContainer.hide();
        self.shippingContainer.show();
        self.serviceArea.show();		      	
      	$(this).addClass('active');
        self.updateCartQuantity();
        self.getValidRegions();
		self.getCart(true);
    });

    $('#shippingAddress1').bind('blur', function(e) {
        if (self.method == "delivery") {
          self.updateShippingAttributes({
            "attributes[Address-Line-1]": $(this).val(),            
          })
        }
    });

    $('#postalCode').bind('blur', function(e) {
        if (self.method == "delivery") {
          self.updateShippingAttributes({
            "attributes[Postal-Code]": $(this).val(),            
          })
        }
    });
    
    this.pickupButton.unbind('click');    
    this.pickupButton.bind('click', function(e) {
        self.method = 'pickup';
    	self.pickupSelector.removeClass('active');
   		self.pickupContainer.show();     
       	self.serviceArea.hide();
        self.shippingContainer.hide();
       	$(this).addClass('active');
        self.getPickupLocations(1, self.searchBox.val(), true);
    });
    
    this.searchBox.keyup(function() {
		self.getPickupLocations(1, $(this).val(), true);
    });
    
	this.checkoutButton.unbind('click');    
    
    this.checkoutButton.bind('click', function(e) {      
        var hasError = false;
      
        if (self.method == 'pickup') {
    	   //check if there is a selected location
          if ($('.pickup-locations li input[type=radio]:checked').length == 0) {
            hasError = true;
            alert("Please select a store pickup location from the list");
            return;
          }                    
        } else {        
          if ($('.pickup-selector.active').length === 0) {
            hasError = true;
            alert("Please select a fulfillment method.");
            return;
          }

          let region = $(self.sprovinceSelector + ' option:selected').text();
          let regionCode = $(self.sprovinceSelector).val();
  
          let city = $(self.scitySelector + ' option:selected').text();
          let cityId = $(self.scitySelector).val();
  
          let barangay = $(self.barangaySelector + ' option:selected').text();
          let barangayId = $(self.barangaySelector).val();
  
          let address1 = $('#shippingAddress1').val();
          let postalCode = $('#postalCode').val();
  
          if (address1 == "") {
            hasError = true;
            alert("Please input an address");
            return false;
          }
  
          if (postalCode == "") {
            hasError = true;
            alert("Please input your postal code");
            return;
          }
          
          if (regionCode == "") {
            hasError = true;
            alert("Please select a province / region");
            return;
          }
  
          if (cityId == "") {
            hasError = true;
            alert("Please select a city / municipality");
            return false;          
          }
  
          if (barangayId == "") {
            hasError = true;
            alert("Please select a barangay");
            return false;          
          }          
        }

        if (!hasError) {
          $('form[name=cart_form]').submit();
        }
    });
              
    $(self.provinceSelector).on('change', function () {      	
      	$(self.citySelector).val($(self.citySelector + ' ' + 'option:first').val().toLowerCase());          

        self.getAllCities();
    });

    
    $(self.citySelector).on('change', function () {
		self.getAllBarangays();
    });
    
    $(self.barangaySelector).on('change', function (event) {
            
    });    
    
    $(".check-area").on('click', function() {
      const province = $(self.provinceSelector).val();
      const city = $(self.citySelector).val();
      const barangay = $(self.barangaySelector).val();

      if(!province){
        console.log("No Province");
        $('.area-check-message').text("Please Select province ");
      }
      
      if(province && !city)
      {
        console.log("No City");
        $('.area-check-message').text("Please Select City ");
      }
      
      if(province && city && !barangay)
      {
        console.log("No Barangay");
        $('.area-check-message').text("Please Select Barangay ");
      }
      
      if(province && city && barangay) {
        $(this).html('Checking ...');
        self.checkArea(barangay);                
      }
    });
  },  
  
  getPickupLocations: function(page, searchField, addPagination) {
    var self = this;    
        
	var url = self.endpoint + "pickup/pickup-stores/?page=" + page;
    
    if (searchField) {
      url += '&search=' + searchField;
    }

    $.get(url, function(data) {
      self.pickupLocations.html('');
      
      var html = '';
      
      for (var i = 0; i < data.results.length; i++) {
		html += '<li>' +
		          '<input type="radio" name="pickup_location_id" value="' + data.results[i].pickup_location_id + '" />' +
        	      '<div class="pickup-data">' +
              		'<p class="pickup-name">' + data.results[i].store_name + '</p>' +
	                '<p class="pickup-address">' + data.results[i].store_address + ' ' + data.results[i].city_name + ', ' + data.results[i].postal_code + '</p>' +
       		        //'<a href="#">More information</a>' +
              	  '</div>' +
              	'</li>';
      }

      self.pickupLocations.html(html);
      
      $('.pickup-locations li').each(function(indx, elem) {
        $(elem).click(function(e) {
	   	  $('.pickup-locations li').removeClass('active');
   		  $(this).addClass('active');
          $(this).find('input[type=radio]').prop("checked", true);
          self.changeCart(data.results[indx], 'pickup');
        });                
      });
            
      $('.pickup-locations li a').each(function(indx, elem) {
        $(elem).click(function(e) {
    	  e.preventDefault();
	      e.stopPropagation();
          
	      const details = data.results[indx];
          
          $.fancybox.open("<div class='location-popup'>" + 
                           	"<h1 class='location-name'>" + details.store_name + "</h1>" +
                          	"<h2 class='location-address'>" + details.store_address + "</h2>" +
                          	"<h2 class='location-address'>" + details.barangay_name + "</h2>" +
                            "<h2 class='location-address'>" + details.city_name + ", " + details.region_name + "</h2>" +
                            "<h2 class='location-address'>" + details.postal_code + "</h2>" +
                          	"<h1 class='location-name mt-2'>Opening hours</h1>" +
                          	"<table>" +
                          		"<tr>" +
                          			"<td class='location-address'>Mon</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Tue</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Wed</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Thu</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Fri</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Sat</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
                          		"<tr>" +
                          			"<td class='location-address'>Sun</td>" + 
                          			"<td class='location-address'>9:00 AM - 6:00 PM</td>" +
                          		"</tr>" +
							  "</table>" +
		          		   "</div>");
        });
      });     		      
      
      if (addPagination) {
        self.addPagination(data.count, searchField)
      }
     
    }).fail(function(error) {
        self.pickupLocations.html('');
    });
  },
  
  addPagination: function(totalItems, searchField) {
    var self = this;
    var isFirst = true;

    $(".store-pagination").html('');
      
    $(".store-pagination").paging(totalItems, {
      format: '[< nncnn! >]',
      perpage: 10,	  
      page: 1,
      lapping: 0,
      onSelect: function(page) {
        if (isFirst) {
          isFirst = false;
        } else {
          self.getPickupLocations(page, searchField, false);
        }
        
      },
      onFormat: function(type) {
        switch (type) {
          case 'block': // n and c
            if (this.page === this.value) {
              return '<span>' + this.value + '</span>';
            } else {
              if (this.value > Math.ceil(totalItems / 10)) {
				return '<a href="#" class="hidden-page">' + this.value + '</a>';
              }
              return '<a href="#">' + this.value + '</a>';
            }
          case 'next': // >
            const next_icon = "//cdn.shopify.com/s/files/1/0553/6078/2429/t/9/assets/caret-right-solid.svg?v=9501424321179041865";
            return '<a class="arrow-icon arrow-icon-small" href="#"><img src="' + next_icon + '" /></a>';
          case 'prev': // <
            const prev_icon = "//cdn.shopify.com/s/files/1/0553/6078/2429/t/9/assets/caret-left-solid.svg?v=17249499475487256981";
            return '<a class="arrow-icon arrow-icon-small" href="#"><img src="' + prev_icon + '" /></a>';
          case 'first': // [
            const first_icon = "//cdn.shopify.com/s/files/1/0553/6078/2429/t/9/assets/backward-step-solid.svg?v=17801460702242899684";
            return '<a class="arrow-icon" href="#"><img src="' + first_icon + '" /></a>';
          case 'last': // ]
            const last_icon = "//cdn.shopify.com/s/files/1/0553/6078/2429/t/9/assets/forward-step-solid.svg?v=3081052075403669404";
            return '<a class="arrow-icon" href="#"><img src="' + last_icon + '" /></a>';
        }
      }
    });
  },
  
  getCart: function(withCallback) {
    var self = this;
    
    $.getJSON(window.Shopify.routes.root + 'cart.js', function(data) {
      self.cartContent = data;
      if (withCallback) {
        self.clearChangeCart();
      } else {
		console.log (data.attributes["Checkout-Method"]);
      }   
    }).fail(function(error) {
       
    });;
  },
  
  clearChangeCart: function() {
    var self = this;
    var clrCtrs = 0;
    
    for (var i = 0; i < self.cartContent.items.length; i++) {
	    $.post(window.Shopify.routes.root + 'cart/change.js', { 
    	  'line' : i + 1,
      	  'properties[_CustomPickupId]': '',        
      	  'quantity' : self.cartContent.items[i].quantity
    	}, function(data) {
          clrCtrs++;
          if (clrCtrs === self.cartContent.items.length) {
		  	self.clearUpdateCart();
          }
	    }).fail(function(error) {
          clrCtrs++;
          
          if (clrCts == self.cartContent.items.length) {
   		  	self.clearUpdateCart();
          }
    	});
    }    
  },
  
  clearUpdateCart: function() {
      let self = this;
    
      $.post(window.Shopify.routes.root + 'cart/update.js', { 
        'attributes[Pickup-Location-Id]': '',
        'attributes[Delivery-Location-Id]': '',
        'attributes[Delivery-Date]': '',
        'attributes[Delivery-Time]': '',
        'attributes[Shipping-Date]': '',
        'attributes[Shipping-Time]': '',
        'attributes[Custom-Attribute-1]': '',
        'attributes[Custom_attribute_2]': '',
        'attributes[Custom-Attribute-3]': '',
        'attributes[Pickup-Location-Company]': '',
        'attributes[Pickup-Location-Address-Line-1]': '',
        'attributes[Pickup-Location-Address-Line-2]': '',
        'attributes[Pickup-Location-Barangay-Id]': '',
        'attributes[Pickup-Location-City]': '',
        'attributes[Pickup-Location-City-Id]': '',
        'attributes[Pickup-Location-Region]': '',
		'attributes[Pickup-Location-Region-Code]': '',
        'attributes[Pickup-Location-Postal-Code]': '',
        'attributes[Pickup-Location-Country]': '',
        'attributes[Delivery-Slot-Id]': '',
        'attributes[Checkout-Method]': 'shipping',
        'attributes[Custom-Attribute-2]': '',
        'attributes[Province]': '',
        'attributes[City-Id]': '',
        'attributes[City]': '',        
        'attributes[Barangay-Id]': '',
        'attributes[Barangay]': '',       
        'attributes[Region-Code]': '',
        'attributes[Postal-Code]': '',
        'attributes[Country]': 'Philippines'        
      }, function(data) {                
		self.getCart(false);
      }).fail(function(error) {

      });
  },

  updateCartQuantity: function() {
    var self = this;
    if (self.cartContent) {
        const item = self.cartContent.items[self.cartContent.items.length - 1];
        lineItem = self.cartContent.items.length;
        quantity = item.quantity;
      }

      console.log ("Update Cart Quantity " + lineItem + " " + quantity);

      $.post(window.Shopify.routes.root + 'cart/change.js', { 
          'line' : lineItem,
          'properties[_CustomPickupId]': null,
          'quantity' : quantity
      }, function(cartData) {
      });
  },
    
  updateShippingAttributes: function(data) {
    var self = this;

    var payload = {
      'attributes[Pickup-Location-Id]': '',
      'attributes[Delivery-Location-Id]': '',
      'attributes[Delivery-Date]': '',
      'attributes[Delivery-Time]': '',
      'attributes[Shipping-Date]': '',
      'attributes[Shipping-Time]': '',
      'attributes[Custom-Attribute-1]': '',
      'attributes[Custom_attribute_2]': '',
      'attributes[Custom-Attribute-3]': '',
      'attributes[Pickup-Location-Company]': '',
      'attributes[Pickup-Location-Address-Line-1]': '',
      'attributes[Pickup-Location-Address-Line-2]': '',
      'attributes[Pickup-Location-Barangay-Id]': '',
      'attributes[Pickup-Location-City]': '',
      'attributes[Pickup-Location-City-Id]': '',
      'attributes[Pickup-Location-Region]': '',
      'attributes[Pickup-Location-Region-Code]': '',
      'attributes[Pickup-Location-Postal-Code]': '',
      'attributes[Pickup-Location-Country]': '',
      'attributes[Delivery-Slot-Id]': '',
      'attributes[Checkout-Method]': 'shipping',
      'attributes[Custom-Attribute-2]': '',      
      'attributes[Country]': 'Philippines'
    }

    $.extend(payload, data);
    
    $.post(window.Shopify.routes.root + 'cart/update.js', payload, function(data) {
        self.getCart(false);
    }).fail(function(error) {
      
    })
  },
  
  updateCart: function(data, method) {
    var self = this;
    
    var pickupLocationId = $('input[name=pickup_location_id]:checked').val();
        
    if (pickupLocationId) {
      $.post(window.Shopify.routes.root + 'cart/update.js', { 
        'attributes[Pickup-Location-Id]': pickupLocationId,
        'attributes[Delivery-Location-Id]': '',
        'attributes[Delivery-Date]': '',
        'attributes[Delivery-Time]': '',
        'attributes[Shipping-Date]': '',
        'attributes[Shipping-Time]': '',
        'attributes[Custom-Attribute-1]': '',
        'attributes[Custom_attribute_2]': '',
        'attributes[Custom-Attribute-3]': '',
        'attributes[Pickup-Location-Company]': data.store_name,
        'attributes[Pickup-Location-Address-Line-1]': data.store_address,
        'attributes[Pickup-Location-Address-Line-2]': data.barangay_name,
        'attributes[Pickup-Location-Barangay-Id]': data.barangay,
        'attributes[Pickup-Location-City]': data.city_name,
        'attributes[Pickup-Location-City-Id]': data.city,
        'attributes[Pickup-Location-Region]': data.region_name,
		'attributes[Pickup-Location-Region-Code]': data.region_code,        
        'attributes[Pickup-Location-Postal-Code]': data.postal_code,
        'attributes[Pickup-Location-Country]': 'Philippines',
        'attributes[Delivery-Slot-Id]': '',
        'attributes[Checkout-Method]': method,
        'attributes[Custom-Attribute-2]': '',
        'attributes[Address-Line-1]': '',
        'attributes[Province]': '',        
        'attributes[City-Id]': '',
        'attributes[City]': '',   
        'attributes[Barangay-Id]': '',
        'attributes[Barangay]': '',
        'attributes[Region-Code]': '',
        'attributes[Postal-Code]': '',
        'attributes[Country]': 'Philippines'
      }, function(data) {                        
        self.getCart(false);
      }).fail(function(error) {

      });
    }
  },
  
  changeCart: function(data, method) {
    var self = this;
    var lineItem = 1;
    var quantity = 1;

    var pickupLocationId = $('input[name=pickup_location_id]:checked').val();
    
    if (pickupLocationId) {
      if (self.cartContent) {
        const item = self.cartContent.items[self.cartContent.items.length - 1];
        lineItem = self.cartContent.items.length;
        quantity = item.quantity;
      }
    
      $.post(window.Shopify.routes.root + 'cart/change.js', { 
          'line' : lineItem,
          'properties[_CustomPickupId]': pickupLocationId,        
          'quantity' : quantity
      }, function(cartData) {
          self.updateCart(data, method);
      }).fail(function(error) {
          self.pickupLocations.html('');
      });
    }
  },
  
  getServiceableRegions: function() {
	var self = this;
    
    $.getJSON(self.endpoint + 'pickup/service-regions/', function(data) {
      var html = '';

      $(self.provinceSelector).html('<option disabled="" selected="" value="">Select Province </option>');

      data.results.forEach(function(item) {
        $(self.provinceSelector).append($('<option>', { 
          value: item.region_code,
          text : item.region_name
        }));		
      });
     
      
    }).fail(function(error) {

  	});
  },
  
  getAllCities: function() {
    var self = this;

    if ($(self.provinceSelector).val() == '') {
      return;
    }

    $('#city').val('');
    $('#barangay').val('');

    $('#city').html('<option disabled="" selected="" value="">Select Municipality</option>');
    $('#barangay').html('<option disabled="" selected="" value="">Select Barangay</option>');

    $.getJSON(self.endpoint + 'pickup/city/?region_code_eq=' + $(self.provinceSelector).val(), function(data) {
      var html = '';

      $(self.citySelector).html('<option disabled="" selected="" value="">Select Municipality</option>');

      data.results.forEach(function(item) {
        $(self.citySelector).append($('<option>', { 
          value: item.city_id,
          text : item.city_name
        }));
      });
                       
    }).fail(function(error) {

    });
  },
  
  getAllBarangays: function() {
    var self = this;

    if ($(self.citySelector).val() == '') {
      return;
    }


    $('#barangay').val('');
    $('#barangay').html('<option disabled="" selected="" value="">Select Barangay</option>');

    $.getJSON(self.endpoint + 'pickup/barangay/?city_id_eq=' + $(self.citySelector).val(), function(data) {
      var html = '';

      $(self.barangaySelector).html('<option disabled="" selected="" value="">Select Barangay</option>');

      data.results.forEach(function(item) {
        $(self.barangaySelector).append($('<option>', { 
          value: item.barangay_id,
          text : item.barangay_name
        }));		
      });

    }).fail(function(error) {

    });
  },

  checkArea: function(barangayId) {
    var self = this;
    
    $.getJSON(self.endpoint + 'pickup/check_area/?barangay_id=' + barangayId, function(data) {
	  $('.check-area').html('Check Area');
      if (data.is_deliverable) {
     	$('.area-check-message').text("Yes, your area is within delivery coverage!");
      } else {
        $('.area-check-message').text("Your area is currently outside our delivery coverage");
      }
    })
    .fail(function(error) {
       $('.check-area').html('Check Area');
    });;
  },

  getValidRegions: function() {
    var self = this;

    $.getJSON(self.endpoint + 'pickup/service-regions/', function(data) {
      var html = '';

      var elem = $("<select id='shipping_province'></select>");

      $(elem).html('<option disabled="" selected="" value="">Select Province</option>')
            
      data.results.forEach(function(item) {
        $(elem).append($('<option>', { 
            value: item.region_code,
            text : item.region_name
        }));		
      });

      let cityElem = $("<select id='shipping_city'><option disabled='' selected='' value=''>Select Municipality</option></select>");
      let barangayElem = $("<select id='shipping_barangay'><option disabled='' selected='' value=''>Select Barangay</option></select>");

      self.shippingBox.html("");
      self.shippingBox.append(elem);
      self.shippingBox.append(cityElem);
      self.shippingBox.append(barangayElem);

      $(self.sprovinceSelector).change(function () {
          $(self.scitySelector).val($(self.scitySelector + ' ' + 'option:first').val().toLowerCase());                            
          let province = $(self.sprovinceSelector + " option:selected").text();
          let regionCode = $(this).val();
          self.updateShippingAttributes({
            "attributes[Province]": province,
            "attributes[Region-Code]": regionCode,
            "attributes[City]" : '',
            "attributes[City-Id]": '',
            "attributes[Barangay]" : '',
            "attributes[Barangay-Id]": '',
          })

          $(self.scitySelector).html("<option disabled='' selected='' value=''>Select Municipality</option>");
          $(self.sbarangaySelector).html("<option disabled='' selected='' value=''>Select Barangay</option>");
        
          self.getValidCities();
      });

      $(self.scitySelector).change(function() {     
        $(self.sbarangaySelector).val($(self.sbarangaySelector + ' ' + 'option:first').val().toLowerCase());                            
        let city = $(self.scitySelector + " option:selected").text();
        let cityId = $(this).val();

        self.updateShippingAttributes({
          "attributes[City]" : city,
          "attributes[City-Id]": cityId,
          "attributes[Barangay]" : '',
          "attributes[Barangay-Id]": ''
        });

        $(self.sbarangaySelector).html("<option disabled='' selected='' value=''>Select Barangay</option>");
        
        self.getValidBarangays();        
      });

      $(self.sbarangaySelector).change(function() {
        let barangay = $(self.sbarangaySelector + " option:selected").text();
        let barangayId = $(this).val();
        
        self.updateShippingAttributes({          
          "attributes[Barangay]" : barangay,
          "attributes[Barangay-Id]": barangayId
        });
      });
    }).fail(function(error) {

    });
  },

  getValidCities: function() {
    var self = this;
    
    if ($(self.sprovinceSelector).val() == '') {
      return;
    }
    
    $(self.scitySelector).val('');
    $(self.sbarangaySelector).val('');
    
    $(self.scitySelector).html('<option disabled="" selected="" value="">Select Municipality</option>');
    $(self.sbarangaySelector).html('<option disabled="" selected="" value="">Select Barangay</option>');

    $.getJSON(self.endpoint + 'pickup/service-cities/?region_code_eq=' + $(self.sprovinceSelector).val(), function(data) {
      var html = '';
      
      $(self.scitySelector).html('<option disabled="" selected="" value="">Select Municipality</option>');

      data.results.forEach(function(item) {
        $(self.scitySelector).append($('<option>', { 
            value: item.city_id,
            text : item.city_name
        }));		
      });                        
      
    }).fail(function(error) {

    });
  },

  getValidBarangays: function() {
    var self = this;

    if ($(self.scitySelector).val() == '') {
      return;
    }
                
    $(self.sbarangaySelector).val('');
    $(self.sbarangaySelector).html('<option disabled="" selected="" value="">Select Barangay</option>');
    
    $.getJSON(self.endpoint + 'pickup/service-barangays/?city_id_eq=' + $(self.scitySelector).val(), function(data) {
      var html = '';
      
      $(self.sbarangaySelector).html('<option disabled="" selected="" value="">Select Barangay</option>');

      data.results.forEach(function(item) {
        $(self.sbarangaySelector).append($('<option>', { 
            value: item.barangay_id,
            text : item.barangay_name
        }));		
      });    
      
    }).fail(function(error) {

    });
  }
}

$(document).ready(function() {
  CustomPickup.init(true);  
});